<template>
  <v-container fluid class="department-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Department</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Photo</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Department</p>
                        <v-text-field
                          type="number"
                          class="mb-4"
                          v-model="department.departmentrank"
                          outlined
                          dense
                          placeholder="Department Rank"
                          persistent-hint
                          single-line hint="Enter the department rank">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="department.departmentcode"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Department Code"
                          persistent-hint
                          single-line hint="Enter the department Code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="department.departmentname"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Department Name"
                          persistent-hint
                          single-line hint="Enter the department name">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items=items
                          v-model="department.departmenttype"
                          v-bind:error="errorindex == 4"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the department type">
                        </v-select>
                          <v-switch
                            v-model="department.departmentstatus"
                            color="primary"
                            v-bind:label="department.departmentstatus"
                            value="Active"
                          ></v-switch>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/department/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Upload Photo</p>
                        <p>Photo:</p>

                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="createDepartment()">
                            Save
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      imageurl: undefined,
      department: {
        departmentstatus: 'Active'
      },
      items: ['Department', 'Other Department'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },

  methods: {
    ...mapActions('Department', [
      'createDepartmentRequest',
      'getDepartmentsRequest'
    ]),
    checkError(){
      if(!this.department.departmentcode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.department.departmentname){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.department.departmenttype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    createDepartment() {
      this.createDepartmentRequest(this.department)
      this.getDepartmentsRequest()
      router.push('/department/list')
    },
    createImage(file) {
      const reader = new FileReader();

      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.department.departmentimage = file;
      this.department.imagename = file.name;
      this.createImage(file);
    }
  },
  computed: {
    ...mapState('Department', ['isReceiving'])
  }

}
</script>

<style src="./Add.scss" lang="scss"></style>
